var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 86,
    viewBox: "0 0 144 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 2H7C4.23858 2 2 4.23858 2 7V79C2 81.7614 4.23857 84 7 84H137C139.761 84 142 81.7614 142 79V48C142 45.2386 139.761 43 137 43H52.5C49.7386 43 47.5 40.7614 47.5 38V7C47.5 4.23858 45.2614 2 42.5 2Z",
    fill: "#AFDB28",
    fillOpacity: 0.2,
    stroke: "#22A156",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5303 8.46967C37.2374 8.17678 36.7626 8.17678 36.4697 8.46967L31.6967 13.2426C31.4038 13.5355 31.4038 14.0104 31.6967 14.3033C31.9896 14.5962 32.4645 14.5962 32.7574 14.3033L37 10.0607L41.2426 14.3033C41.5355 14.5962 42.0104 14.5962 42.3033 14.3033C42.5962 14.0104 42.5962 13.5355 42.3033 13.2426L37.5303 8.46967ZM36.4697 36.5303C36.7626 36.8232 37.2374 36.8232 37.5303 36.5303L42.3033 31.7574C42.5962 31.4645 42.5962 30.9896 42.3033 30.6967C42.0104 30.4038 41.5355 30.4038 41.2426 30.6967L37 34.9393L32.7574 30.6967C32.4645 30.4038 31.9896 30.4038 31.6967 30.6967C31.4038 30.9896 31.4038 31.4645 31.6967 31.7574L36.4697 36.5303ZM36.25 9L36.25 36L37.75 36L37.75 9L36.25 9Z",
    fill: "#22A156"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8636 29.5H12.9347L12.9347 14.9545H17.9631C19.4072 14.9545 20.6477 15.2457 21.6847 15.8281C22.7263 16.4058 23.5265 17.2367 24.0852 18.321C24.6439 19.4053 24.9233 20.7027 24.9233 22.2131C24.9233 23.7282 24.6416 25.0303 24.0781 26.1193C23.5194 27.2083 22.7121 28.044 21.6563 28.6264C20.6051 29.2088 19.3409 29.5 17.8636 29.5ZM15.5696 27.2202H17.7358C18.7491 27.2202 19.5942 27.0355 20.2713 26.6662C20.9484 26.2921 21.4574 25.7358 21.7983 24.9972C22.1392 24.2538 22.3097 23.3258 22.3097 22.2131C22.3097 21.1004 22.1392 20.1771 21.7983 19.4432C21.4574 18.7045 20.9531 18.1529 20.2855 17.7884C19.6226 17.419 18.7988 17.2344 17.8139 17.2344H15.5696L15.5696 27.2202Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLd);
export default __webpack_public_path__ + "static/media/ld.08edb8be9d4617678921aed57c4337b7.svg";
export { ForwardRef as ReactComponent };